import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios';

export const getPayments = createAsyncThunk('get/payments', async (params) => {
  const response = await axios.get('/charging-session/', {
    params,
  });
  return response.data;
});

export const getPaymentsByProvider = createAsyncThunk(
  'get/getPaymentsByProvider',
  async ({ providers, page, limit }, { rejectWithValue }) => {
    try {
      const response = await axios.get('/charging-session/', {
        params: {
          providers,
          page,
          limit,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getInvoices = createAsyncThunk('get/invoices', async ({ startDate, endDate }) => {
  const response = await axios.get('/invoice/', {
    params: {
      query: '',
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response.data;
});

export const getPaymentLogs = createAsyncThunk('get/paymentLogs', async ({ startDate, endDate }) => {
  const response = await axios.get('/payment_logs/', {
    params: {
      query: '',
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response.data;
});

export const getBillingTypes = createAsyncThunk('get/billingTypes', async () => {
  const response = await axios.get('/billing-type/');
  return response.data;
});

export const addBillingType = createAsyncThunk('billing/type', async (billingData, { rejectWithValue }) => {
  try {
    const response = await axios.post('/billing-type/', billingData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const setTaxFree = createAsyncThunk('set/taxFree', async (chargerIDs, { rejectWithValue }) => {
  try {
    const response = await axios.post('/billing-type/free_tax/', chargerIDs);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getUserPayments = createAsyncThunk('get/userPayments', async (userID) => {});

const paymentAdapter = createEntityAdapter({});

const paymentSlice = createSlice({
  name: 'payments',
  initialState: paymentAdapter.getInitialState({
    payments: [],
    paymentsByProvider: [],
    invoices: [],
    paymentLogs: [],
    billingTypes: [],
    isLoading: false,
    loading: false,
  }),
  reducers: {
    clearPayments: (state) => {
      state.paymentsByProvider = [];
      state.payments = [];
    },
  },
  extraReducers: {
    [getPaymentsByProvider.pending]: (state) => {
      state.isLoading = true;
    },
    [getPaymentsByProvider.fulfilled]: (state, action) => {
      state.paymentsByProvider = action.payload.data;
      state.isLoading = false;
    },
    [getPaymentsByProvider.rejected]: (state) => {
      state.isLoading = false;
    },
    [getPayments.pending]: (state) => {
      state.isLoading = true;
    },
    [getPayments.fulfilled]: (state, action) => {
      state.payments = action.payload.data;
      state.isLoading = false;
    },
    [getPayments.rejected]: (state) => {
      state.isLoading = false;
    },
    [getInvoices.pending]: (state) => {
      state.isLoading = true;
    },
    [getInvoices.fulfilled]: (state, action) => {
      state.invoices = action.payload.data;
      state.isLoading = false;
    },
    [getInvoices.rejected]: (state) => {
      state.isLoading = false;
    },
    [getPaymentLogs.pending]: (state) => {
      state.loading = true;
    },
    [getPaymentLogs.fulfilled]: (state, action) => {
      state.paymentLogs = action.payload.data;
      state.loading = false;
    },
    [getPaymentLogs.rejected]: (state) => {
      state.loading = false;
    },
    [getBillingTypes.fulfilled]: (state, action) => {
      state.billingTypes = action.payload.data;
    },
    [addBillingType.pending]: (state) => {
      state.isLoading = true;
    },
    [addBillingType.fulfilled]: (state) => {
      state.isLoading = false;
    },
    [addBillingType.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { clearPayments } = paymentSlice.actions;

export default paymentSlice.reducer;
